import {Component, Input, OnChanges, SimpleChanges} from '@angular/core';
import {ImpactMetricValue} from "it/primatoo/openapi/api/org/schemas/common/ImpactMetricValue";
import {
  DEFAULT_GAUGE_PALETTE,
  DetailsChartGaugeColor,
  IoniconsOutline,
  RID_GAUGE_PALETTE_MAX_3,
  RISK_ASSESSMENT_GAUGE_PALETTE_MAX_5
} from "@pt/pt-models";
import {EChartsOption} from "echarts";
import {Observable, of} from "rxjs";
import {TranslateService} from "@ngx-translate/core";

@Component({
  selector: 'pt-rid-viewer',
  template: `
    <div class="pt-rid-viewer">
      <div class="rid-title">
        {{ title }}
      </div>
      <div class="chart-container">
        <div class="charts"
             [ngStyle]="{'min-width': minWidth}"
             *ngFor='let chart of charts'>
          <div echarts
               class='chart'
               [options]='chart.options'>
          </div>
          <div class="value">
            {{ chart.value }}
          </div>
          <div class="detail">
            <div class="label">
              {{ chart.label | async }}
            </div>
            <div class="description">
              {{ chart.description | async }}
            </div>
          </div>
        </div>
      </div>
    </div>
  `,
  styleUrls: [`rid-viewer.component.scss`]
})
export class RidViewerComponent implements OnChanges {
  @Input() title?: string;
  @Input() impactMetrics: Array<ImpactMetricValue>;
  @Input() impactMetricsLabels: Array<string>;
  @Input() withTransaction = false;
  @Input() gaugeColor: DetailsChartGaugeColor[] = DEFAULT_GAUGE_PALETTE;
  @Input() minWidth = '180px';
  public changeCounter = 0;
  public charts: RidChartsDto[] = [];
  IconWarning = IoniconsOutline.warning;
  ND = 'LABELS.NA';
  defaultColor = '#333333';

  constructor(private i18n: TranslateService) {
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.impactMetricsLabels && changes.impactMetricsLabels.currentValue) {
      if (changes.impactMetricsLabels.currentValue.length === 5) {
        this.gaugeColor = RISK_ASSESSMENT_GAUGE_PALETTE_MAX_5
      } else {
        this.gaugeColor = RID_GAUGE_PALETTE_MAX_3;
      }
      const items = this.impactMetrics || [
        {key: "CONFIDENTIALITY_VIOLATION", label: "Riservatezza", value: 0},
        {key: "INTEGRITY_COMPROMISE", label: "Integrità", value: 0},
        {key: "AVAILABILITY_LOSS", label: "Disponibilità", value: 0}
      ];
      this.charts = [];
      items.forEach(item => {
        this.charts.push({
          label: of(changes.impactMetricsLabels.currentValue[item.value]),
          description: of(item.label),
          value: item.value,
          options: this.generateChartPieOption(item)
        })
      })

    }


  }

  generateChartPieOption(item: ImpactMetricValue): EChartsOption {
    let currentValue = 0;
    if (item?.value !== null && item?.value !== undefined) {
      currentValue = item.value;
    }
    const currentMaxValue = 5;
    return {
      series: [
        {
          top: '0px',
          left: '0px',
          avoidLabelOverlap: false,
          type: 'pie',
          radius: ['65%', '55%'],
          center: ['50%', '50%'],
          animation: true,
          emphasis: {
            label: {
              show: false
            }
          },
          label: {
            show: false
          },
          labelLine: {
            show: false
          },
          tooltip: {
            show: false
          },
          data: [
            {value: currentMaxValue, itemStyle: {color: this.getColor(currentValue)}},
          ]
        }
      ]
    } as EChartsOption;
  }

  public getColor(currentValue: number) {
    const color = this.gaugeColor.sort((a, b) => a.maxValue > b.maxValue ? 1 : -1);
    for (const c of color) {
      if (currentValue <= c.maxValue) {
        return c.color;
      }
    }
    return this.defaultColor;
  }
}

export interface RidChartsDto {
  label: Observable<string>;
  description: Observable<string>;
  value: number;
  options: EChartsOption;
}
